import { BiometricReloginType } from '@tob/shared/biometrics/constants';
import { GetBiometricsReloginTypeFunctionParameter } from '@shopee-user/business-customization-types';

// return milliseconds
const getActivationCooldownInterval = () => {
  return 0;
};

const getBiometricsReloginType = (
  _: GetBiometricsReloginTypeFunctionParameter
) => {
  return BiometricReloginType.Biometric;
};

export { getActivationCooldownInterval, getBiometricsReloginType };
